import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../auth";
import Button from "../../components/button";

import styles from "./login.module.css";

export default function Login() {
  const history = useHistory();
  const { login, isAuthenticated, loading } = useAuth();

  React.useEffect(() => {
    if (!loading && isAuthenticated) {
      history.replace("/");
    }
  }, [loading, history, isAuthenticated]);

  return (
    <div className={styles.page}>
      <h1>Logbook Admin.</h1>
      <Button
        // disabled={loading}
        className={styles.btn}
        onClick={login}
      >
        Login
      </Button>
    </div>
  );
}
